import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  updateDoc,
  doc,
  increment,
} from "firebase/firestore";
import { db } from "../config"; // Adjust to your actual Firebase config path
import NavBar from "./NavBar";

function Deposits() {
  const [deposits, setDeposits] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState(null);

  const fetchDeposits = async (next = false) => {
    setLoading(true);
    try {
      const depositRef = collection(db, "deposits");
      let q = query(depositRef, orderBy("timestamp", "desc"), limit(10));

      if (next && lastVisible) {
        q = query(
          depositRef,
          orderBy("timestamp", "desc"),
          startAfter(lastVisible),
          limit(10)
        );
      }

      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      setDeposits((prev) => (next ? [...prev, ...data] : data));
      setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    } catch (error) {
      console.error("Error fetching deposits:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDeposits();
  }, []);

const handleStatusChange = async (id, newStatus, deposit) => {
  // Prevent status change if it's already marked as 'success'
  if (deposit.status === "success") return;

  setStatusUpdating(id);
  try {
    const depositRef = doc(db, "deposits", id);
    await updateDoc(depositRef, { status: newStatus });

    // If status is success, update user balance
    if (newStatus === "success") {
      const userRef = doc(db, "users", deposit.userId);
      await updateDoc(userRef, {
        balance: increment(deposit.amount),
      });
    }

    // Update local state
    setDeposits((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, status: newStatus } : item
      )
    );
  } catch (error) {
    console.error("Failed to update status:", error);
  }
  setStatusUpdating(null);
};


  return (
    <div className="container-fluid px-3 py-4">
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>

      <NavBar />

      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <h3 className="text-center mb-4">Deposits</h3>
          {loading && <div className="text-center mb-3">Loading...</div>}

          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-dark">
                <tr>
                  <th>Email</th>
                  <th>Method</th>
                  <th>Amount</th>
                  <th>Timestamp</th>
                  <th>Status</th>
                  <th>Change Status</th>
                </tr>
              </thead>
              <tbody>
                {deposits.map((deposit) => (
                  <tr key={deposit.id}>
                    <td className="text-break">{deposit.userEmail}</td>
                    <td>{deposit.method}</td>
                    <td>${deposit.amount.toFixed(2)}</td>
                    <td>{new Date(deposit.timestamp).toLocaleString()}</td>
                    <td>
                      <span
                        className={`badge bg-${
                          deposit.status === "success"
                            ? "success"
                            : deposit.status === "failed"
                            ? "danger"
                            : "warning"
                        }`}
                      >
                        {deposit.status}
                      </span>
                    </td>
                    <td>
                      <select
                        className="form-select form-select-sm"
                        disabled={statusUpdating === deposit.id}
                        value={deposit.status}
                        onChange={(e) =>
                          handleStatusChange(
                            deposit.id,
                            e.target.value,
                            deposit
                          )
                        }
                      >
                        <option value="pending">Pending</option>
                        <option value="success">Success</option>
                        <option value="failed">Failed</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {lastVisible && (
            <div className="text-center mt-3">
              <button
                className="btn btn-outline-primary"
                onClick={() => fetchDeposits(true)}
                disabled={loading}
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Deposits;
